const PRINCIPLES = [
  {
    k: "01",
    title: "Systems thinking, not tool-chasing",
    body: "Every workflow is a system with inputs, handoffs and outputs. We diagnose the system before we recommend a tool.",
  },
  {
    k: "02",
    title: "Process improvement mindset",
    body: "Background in improving workflows, reporting and operational visibility inside systems-heavy and manufacturing environments — where slack isn't tolerated.",
  },
  {
    k: "03",
    title: "Practical problem-solving",
    body: "We don't implement AI to look modern. We implement it when it measurably saves time, captures more leads or reduces errors.",
  },
  {
    k: "04",
    title: "Focus on measurable outcomes",
    body: "Every recommendation ties back to a business metric: faster response, fewer missed leads, fewer manual hours, better visibility.",
  },
];

export default function TrustSection() {
  return (
    <section
      className="relative bg-zinc-950 text-white overflow-hidden"
      data-testid="trust-section"
    >
      <div className="absolute inset-0 bg-grid-dark opacity-30 pointer-events-none" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-3">
              <span className="inline-block h-px w-10 bg-orange-500" />
              <span className="font-mono text-xs uppercase tracking-[0.22em] text-orange-500 font-semibold">
                Why Work With Us
              </span>
            </div>
            <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              An honest operator. Not an agency pitch.
            </h2>
            <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
              Fynix Systems is a small, deliberate practice. You won't get a sales team or a
              deck full of logos you don't recognise. You'll get a direct working
              relationship with someone who actually untangles operations for a living.
            </p>
            <p className="mt-4 text-zinc-400 leading-relaxed">
              We'd rather tell you something uncomfortable than pitch you something you don't
              need. If AI isn't the right answer, we'll say so.
            </p>
          </div>

          <div className="lg:col-span-7">
            <ul className="grid sm:grid-cols-2 gap-px bg-zinc-800 border border-zinc-800">
              {PRINCIPLES.map((p, i) => (
                <li
                  key={p.k}
                  className="bg-zinc-950 p-7 sm:p-8 reveal"
                  data-testid={`principle-${i}`}
                >
                  <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-orange-500">
                    Principle {p.k}
                  </div>
                  <h3 className="mt-3 font-display font-semibold text-xl tracking-tight text-white">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-zinc-400 leading-relaxed text-sm">{p.body}</p>
                </li>
              ))}
            </ul>

            <div className="mt-8 border-l-2 border-orange-500 pl-5 reveal">
              <p className="font-display text-xl sm:text-2xl text-white leading-snug tracking-tight">
                "The goal isn't to add AI to your business. It's to remove the things slowing
                it down — and sometimes AI is the cleanest way to do that."
              </p>
              <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.22em] text-zinc-500">
                — Fynix Systems
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
